import * as React from 'react';
import { compose } from 'redux';
import { DEFAULT_TO_ALL, LIVE_SIDEBAR_NAV_MAIN_MARKETS } from './live-event-sidebar-match-list.constants';
import preLoader from '@om-fe/core/core/bootstrap/preload';
import {
    addMoreLiveMatchList as addMoreLiveMatchListAction,
    getLiveMatchList,
    removeLiveMatchList,
    updateLiveMatchList,
} from '../../../match-list/containers/live-match-list/live-match-list.actions';
import { DEFAULT_DISPLAYED_NUMBER_OF_MATCHES } from '../../../match-list/utils/match-list.constants';
import { areLiveMatchListTopicPropsEqual } from '../../../match-list/containers/live-match-list/live-match-list.utils';
import MatchList from '../../../match-list/match-list';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { LiveMatchListStoreModel } from '../../../match-list/containers/live-match-list/live-match-list.constants';
import { LiveMatchListPublicProps } from '../../../match-list/containers/live-match-list/live-match-list';
import { LIVE_SIDEBAR_COMPONENT } from '../sports-sidebar/live-event-sidebar.constants';
import { getLiveSidebarComponentSliceName as getSliceKey } from '../sports-sidebar/live-event-sidebar.utils';
import getSlice from '@om-fe/core/utils/get-slice';
import { DisciplineLiveStatus } from '@om-fe/models';
import MatchListSkeleton from '../../../match-list/match-list-skeleton';

type LiveEventSidebarMatchListPublicProps = LiveMatchListPublicProps;

interface LiveEventSidebarMatchListStoreProps {
    readonly sliceKey: string;
    readonly totalRecords?: number;
    readonly limit?: number;
}

interface LiveMatchListDispatchProps {
    readonly addMore: typeof addMoreLiveMatchListAction;
}

type LiveEventSidebarMatchListProps = LiveEventSidebarMatchListPublicProps
    & LiveEventSidebarMatchListStoreProps
    & LiveMatchListDispatchProps;

class LiveEventSidebarMatchListComponent extends React.Component<LiveEventSidebarMatchListProps> {
    render(): React.ReactNode {

        return (
            <MatchList
                {...this.props}
                liveStatus={DisciplineLiveStatus.LIVE}
            />
        );
    }
}

const LiveEventSidebarMatchList: React.ComponentType<LiveEventSidebarMatchListPublicProps> = compose(
    preLoader<LiveEventSidebarMatchListPublicProps>({
        preload({ props, dispatch }): void {
            const { disciplineId, instanceId, limitNumberOfEvents, isAuthenForTopic } = props;

            const limit: number = limitNumberOfEvents || DEFAULT_DISPLAYED_NUMBER_OF_MATCHES;

            dispatch(
                getLiveMatchList(
                    instanceId,
                    disciplineId,
                    limit,
                    DEFAULT_TO_ALL,
                    undefined,
                    LIVE_SIDEBAR_NAV_MAIN_MARKETS,
                    undefined,
                    isAuthenForTopic,
                ),
            );
        },
        getReadySlice({ instanceId }): string {
            const sliceKey: string = getSliceKey(LIVE_SIDEBAR_COMPONENT.LIST, instanceId);

            return `${sliceKey}.ready`;
        },
        update({ props, prevProps, dispatch }): void {
            const { disciplineId, instanceId, limitNumberOfEvents, isAuthenForTopic } = props;

            const limit: number = limitNumberOfEvents || DEFAULT_DISPLAYED_NUMBER_OF_MATCHES;

            if (instanceId !== prevProps.instanceId) {
                dispatch(removeLiveMatchList(prevProps.instanceId));
                dispatch(getLiveMatchList(instanceId, disciplineId, limit, DEFAULT_TO_ALL, undefined, LIVE_SIDEBAR_NAV_MAIN_MARKETS, undefined, isAuthenForTopic));
            } else if (!areLiveMatchListTopicPropsEqual(prevProps, props)) {
                dispatch(updateLiveMatchList(instanceId, disciplineId, limit, DEFAULT_TO_ALL, undefined, LIVE_SIDEBAR_NAV_MAIN_MARKETS, undefined, isAuthenForTopic));
            }
        },
        destroy({ props, dispatch }): void {
            const { instanceId } = props;
            dispatch(removeLiveMatchList(instanceId));
        },
        loadingAnimation: MatchListSkeleton,
    }),
    connect<LiveEventSidebarMatchListStoreProps, LiveMatchListDispatchProps>(
        (state: AppState, props: LiveEventSidebarMatchListPublicProps): LiveEventSidebarMatchListStoreProps => {
            const { instanceId } = props;

            const sliceKey: string = getSliceKey(LIVE_SIDEBAR_COMPONENT.LIST, instanceId);
            const slice = getSlice<LiveMatchListStoreModel>(state, sliceKey);

            if (!slice) {
                return {
                    sliceKey,
                };
            }

            const { totalRecords, limit } = slice;

            return {
                sliceKey,
                totalRecords,
                limit,
            };
        },
        {
            addMore: addMoreLiveMatchListAction,
        },
    ),
)(LiveEventSidebarMatchListComponent);
export default LiveEventSidebarMatchList;
